var _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlucose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Glucose",
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 112,
    viewBox: "0 0 109 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-0.135 0.024)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Icon.BG",
    cx: 54.5,
    cy: 56,
    rx: 54.5,
    ry: 56,
    transform: "translate(0.135 -0.024)",
    fill: "#faeaea"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1250",
    "data-name": "Ellipse 1250",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(28.201 22.12)",
    fill: "red",
    opacity: 0.257
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1251",
    "data-name": "Ellipse 1251",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(65.201 45.12)",
    fill: "red",
    opacity: 0.257
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1252",
    "data-name": "Ellipse 1252",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(30.201 62.12)",
    fill: "red",
    opacity: 0.257
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1253",
    "data-name": "Ellipse 1253",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(32.201 26.12)",
    fill: "#d10909",
    opacity: 0.305
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1254",
    "data-name": "Ellipse 1254",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(34.201 66.12)",
    fill: "#d10909",
    opacity: 0.305
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1255",
    "data-name": "Ellipse 1255",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(69.201 49.12)",
    fill: "#d10909",
    opacity: 0.305
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlucose);
export default __webpack_public_path__ + "static/media/Glucose.e35459635c62844dc742ce66dac5f1c3.svg";
export { ForwardRef as ReactComponent };